export default [
    {
        'text': 'Principal',
        'value': 0
    },
    {
        'text': 'Spouse',
        'value': 1
    },
    {
        'text': 'Dependent',
        'value': 2
    }
];
